import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["key", "layerKey", "options"],
    _excluded2 = ["features", "style", "hoverable", "pointAsMarker"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useCallback, useRef } from 'react';
import { readPixelsToArray } from '@luma.gl/core';
import PropTypes from 'prop-types';
import { isArray as _isArray, isEmpty as _isEmpty } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import DeckGL from '@deck.gl/react';
import { Layer, MapView } from '@deck.gl/core';
import viewport from '../utils/viewport';
import viewHelpers from './helpers/view';
import styleHelpers from './helpers/style';
import TiledLayer from './layers/TiledLayer';
import VectorLayer from './layers/VectorLayer';
import WmsLayer from './layers/WmsLayer';
import './style.scss';
import DeckTooltip from './DeckTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var defaultGetCursor = function defaultGetCursor(_ref) {
  var isDragging = _ref.isDragging;
  return isDragging ? 'grabbing' : 'grab';
};

var DeckGlMap = function DeckGlMap(_ref2) {
  var getCursor = _ref2.getCursor,
      onResize = _ref2.onResize,
      onViewChange = _ref2.onViewChange,
      onZoomEnd = _ref2.onZoomEnd,
      onPanEnd = _ref2.onPanEnd,
      viewLimits = _ref2.viewLimits,
      view = _ref2.view,
      _ref2$onClick = _ref2.onClick,
      _onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
      onLayerClick = _ref2.onLayerClick,
      mapKey = _ref2.mapKey,
      backgroundLayer = _ref2.backgroundLayer,
      layers = _ref2.layers,
      Tooltip = _ref2.Tooltip,
      tooltipProps = _ref2.tooltipProps,
      controller = _ref2.controller;

  var deckRef = useRef();
  var prevViewRef = useRef(null);
  var nextViewRef = useRef(null);
  var zoomingTimeoutRef = useRef(null);

  var _useState = useState({
    width: null,
    height: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      box = _useState2[0],
      setBox = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      stateView = _useState4[0],
      setStateView = _useState4[1];

  var _useState5 = useState({
    vector: [],
    raster: [],
    event: null
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      tooltipData = _useState6[0],
      setTooltipData = _useState6[1];

  var onHover = useCallback(function (event) {
    var _deckRef$current;

    if (deckRef !== null && deckRef !== void 0 && (_deckRef$current = deckRef.current) !== null && _deckRef$current !== void 0 && _deckRef$current.pickMultipleObjects) {
      var _deckRef$current2;

      var hoveredItems = deckRef === null || deckRef === void 0 ? void 0 : (_deckRef$current2 = deckRef.current) === null || _deckRef$current2 === void 0 ? void 0 : _deckRef$current2.pickMultipleObjects(event);
      var vectorHoveredItems = [];
      var rasterHoveredItems = [];
      hoveredItems.forEach(function (item) {
        if (item.layer instanceof VectorLayer) {
          //add to vector items
          vectorHoveredItems.push(item);
        } else if (item.layer instanceof WmsLayer) {
          var _item$tile, _item$tile$layers, _item$tile$layers$, _item$tile$layers$$pr, _item$tile$layers$$pr2, _item$tile$layers$$pr3, _item$tile$layers$$pr4, _item$tile$layers$$pr5, _event$bitmap, _event$bitmap$pixel, _event$bitmap2, _event$bitmap2$pixel;

          //add to raster items
          //this is path fot tile layer
          var image = item === null || item === void 0 ? void 0 : (_item$tile = item.tile) === null || _item$tile === void 0 ? void 0 : (_item$tile$layers = _item$tile.layers) === null || _item$tile$layers === void 0 ? void 0 : (_item$tile$layers$ = _item$tile$layers[0]) === null || _item$tile$layers$ === void 0 ? void 0 : (_item$tile$layers$$pr = _item$tile$layers$.props) === null || _item$tile$layers$$pr === void 0 ? void 0 : (_item$tile$layers$$pr2 = _item$tile$layers$$pr.tile) === null || _item$tile$layers$$pr2 === void 0 ? void 0 : (_item$tile$layers$$pr3 = _item$tile$layers$$pr2.layers) === null || _item$tile$layers$$pr3 === void 0 ? void 0 : (_item$tile$layers$$pr4 = _item$tile$layers$$pr3[0]) === null || _item$tile$layers$$pr4 === void 0 ? void 0 : (_item$tile$layers$$pr5 = _item$tile$layers$$pr4.props) === null || _item$tile$layers$$pr5 === void 0 ? void 0 : _item$tile$layers$$pr5.image;
          item.pixelColor = readPixelsToArray(image, {
            sourceX: event === null || event === void 0 ? void 0 : (_event$bitmap = event.bitmap) === null || _event$bitmap === void 0 ? void 0 : (_event$bitmap$pixel = _event$bitmap.pixel) === null || _event$bitmap$pixel === void 0 ? void 0 : _event$bitmap$pixel[0],
            sourceY: event === null || event === void 0 ? void 0 : (_event$bitmap2 = event.bitmap) === null || _event$bitmap2 === void 0 ? void 0 : (_event$bitmap2$pixel = _event$bitmap2.pixel) === null || _event$bitmap2$pixel === void 0 ? void 0 : _event$bitmap2$pixel[1],
            sourceWidth: 1,
            sourceHeight: 1
          });
          rasterHoveredItems.push(item);
        }
      });

      if (Tooltip) {
        setTooltipData({
          vector: vectorHoveredItems,
          raster: rasterHoveredItems,
          event: event
        });
      }
    }
  }, [deckRef.current]);

  var getViewChange = function getViewChange(prevView, nextView) {
    var change = {};

    if (prevView && prevView.zoom !== nextView.zoom) {
      change.boxRange = viewHelpers.getBoxRangeFromZoomLevel(nextView.zoom, box.width, box.height);
    }

    if (prevView && (prevView.longitude !== nextView.longitude || prevView.latitude !== nextView.latitude)) {
      change.center = {
        lat: nextView.latitude,
        lon: nextView.longitude
      };
    }

    if (prevView && prevView.bearing !== nextView.bearing) {
      change.bearing = nextView.bearing;
    }

    if (prevView && prevView.pitch !== nextView.pitch) {
      change.pitch = nextView.pitch;
    }

    return change;
  };

  var onViewStateChange = function onViewStateChange(views) {
    var prevView = views.oldViewState;
    var nextView = views.viewState;

    if (views.interactionState.isZooming) {
      prevViewRef.current = prevView;
      nextViewRef.current = nextView;
      window.clearTimeout(zoomingTimeoutRef.current);
      zoomingTimeoutRef.current = window.setTimeout(function () {
        if (typeof onZoomEnd === 'function') {
          var _change = getViewChange(prevView, nextView);

          onZoomEnd(_change);
        }
      }, 100);
    } // Type of transition
    // views.interactionState.inTransition


    var change = getViewChange(prevView, nextView);

    if (!_isEmpty(change)) {
      if (onViewChange) {
        onViewChange(change);
      } // just presentational map
      else {
        setStateView(_objectSpread(_objectSpread(_objectSpread({}, view), stateView), change));
      }
    }
  };
  /**
   * @param width {number}
   * @param height {number}
   */


  var onResizeHandler = useCallback(function (width, height) {
    var updateHeight = viewport.roundDimension(height);
    var updateWidth = viewport.roundDimension(width);

    if (onResize) {
      onResize(updateWidth, updateHeight);
    }

    setBox({
      width: updateWidth,
      height: updateHeight
    });
  });
  /**
   * @param layerKey {string}
   * @param featureKeys {Array}
   * @param position {{x: Number, y: Number}}
   */

  var onVectorLayerClick = function onVectorLayerClick(layerKey, featureKeys, position) {
    if (onLayerClick) {
      onLayerClick(mapKey, layerKey, featureKeys, position);
    }
  };
  /**
   * @param layerKey {string}
   * @param info {Object}
   * @param event {Object}
   */


  var onRasterLayerClick = function onRasterLayerClick(layerKey, info, event) {
    if (onLayerClick) {
      onLayerClick(mapKey, layerKey, null, {
        x: info.x,
        y: info.y
      }, {
        event: event,
        info: info
      });
    }
  };
  /**
   * Return tiled (WMTS) layer
   * @param layer {Object} layer data
   * @returns {TiledLayer}
   */


  var getTileLayer = function getTileLayer(layer) {
    return new TiledLayer(_objectSpread(_objectSpread({}, layer), {}, {
      id: layer.key
    }));
  };
  /**
   * Return WMS layer
   * @param layer {Object} layer data
   * @returns {WmsLayer}
   */


  var getWmsLayer = function getWmsLayer(layer) {
    var _layer$options;

    if ((_layer$options = layer.options) !== null && _layer$options !== void 0 && _layer$options.singleTile) {
      throw new Error('DeckGlMap: singleTile option not implemented yet!');
    } else {
      return new WmsLayer(_objectSpread(_objectSpread({}, layer), {}, {
        id: layer.key,
        onClick: onRasterLayerClick
      }));
    }
  };
  /**
   * Return vector layer
   * TODO it supports only points and polygons currently
   * @param layer {Object} layer data
   * @returns {VectorLayer}
   */


  var getVectorLayer = function getVectorLayer(layer) {
    var _renderAsRules$option;

    // eslint-disable-next-line no-unused-vars
    var key = layer.key,
        layerKey = layer.layerKey,
        options = layer.options,
        restProps = _objectWithoutProperties(layer, _excluded); // eslint-disable-next-line no-unused-vars


    var features = options.features,
        style = options.style,
        hoverable = options.hoverable,
        pointAsMarker = options.pointAsMarker,
        restOptions = _objectWithoutProperties(options, _excluded2);

    var renderAsRules = styleHelpers.getRenderAsRulesByBoxRange(options.renderAs, view === null || view === void 0 ? void 0 : view.boxRange); // Check options for renderAsRules
    // TODO add other options

    style = (renderAsRules === null || renderAsRules === void 0 ? void 0 : (_renderAsRules$option = renderAsRules.options) === null || _renderAsRules$option === void 0 ? void 0 : _renderAsRules$option.style) || style;
    pointAsMarker = Object.hasOwn((renderAsRules === null || renderAsRules === void 0 ? void 0 : renderAsRules.options) || {}, 'pointAsMarker') ? renderAsRules.options.pointAsMarker : options.pointAsMarker;
    var styleForDeck = styleHelpers.getStylesDefinitionForDeck(style, key);

    var props = _objectSpread(_objectSpread({}, restProps), {}, {
      options: options,
      id: layer.key,
      key: layer.key,
      layerKey: layer.layerKey || layer.key,
      onClick: onVectorLayerClick,
      autoHighlight: hoverable,
      styleForDeck: styleForDeck,
      pointAsMarker: pointAsMarker
    });

    return new VectorLayer(props);
  };
  /**
   * Return layer by type
   * @param layer {Object} layer data
   * @returns {TiledLayer|VectorLayer|WmsLayer|null}
   */


  var getLayerByType = function getLayerByType(layer) {
    if (layer && layer instanceof Layer) {
      return layer;
    } else if (layer && layer.type) {
      switch (layer.type) {
        case 'wmts':
          return getTileLayer(layer);

        case 'wms':
          return getWmsLayer(layer);

        case 'vector':
          return getVectorLayer(layer);

        default:
          return null;
      }
    } else {
      return null;
    }
  };

  var renderTooltip = function renderTooltip() {
    var _tooltipData$vector, _tooltipData$raster;

    tooltipData.mapKey = mapKey;

    if (tooltipData !== null && tooltipData !== void 0 && (_tooltipData$vector = tooltipData.vector) !== null && _tooltipData$vector !== void 0 && _tooltipData$vector.length || tooltipData !== null && tooltipData !== void 0 && (_tooltipData$raster = tooltipData.raster) !== null && _tooltipData$raster !== void 0 && _tooltipData$raster.length) {
      return /*#__PURE__*/_jsx(DeckTooltip, _objectSpread({
        Tooltip: Tooltip,
        data: tooltipData,
        mapWidth: box === null || box === void 0 ? void 0 : box.width,
        mapHeight: box === null || box === void 0 ? void 0 : box.height,
        mapKey: mapKey
      }, tooltipProps));
    }
  };

  var renderMap = function renderMap() {
    var renderView = onViewChange || !stateView ? view : stateView;
    var deckView = viewHelpers.getDeckViewFromPantherViewParams(renderView, box.width, box.height, viewLimits);
    var backgroundLayersSource = _isArray(backgroundLayer) ? backgroundLayer : [backgroundLayer];
    var finalBackgroundLayers = backgroundLayersSource && backgroundLayersSource.map(function (layer) {
      return getLayerByType(layer);
    });
    var finalLayers = layers ? layers.map(function (layer) {
      return getLayerByType(layer);
    }) : [];
    return /*#__PURE__*/_jsxs("div", {
      className: "ptr-deckGl-map ptr-map",
      onClick: function onClick() {
        return _onClick(mapKey);
      },
      children: [/*#__PURE__*/_jsx(DeckGL, _objectSpread(_objectSpread({
        getCursor: getCursor || defaultGetCursor,
        ref: deckRef,
        onViewStateChange: onViewStateChange
      }, typeof onPanEnd === 'function' ? {
        onDragEnd: onPanEnd
      } : {}), {}, {
        views: new MapView({
          repeat: true
        }),
        viewState: deckView,
        layers: [].concat(_toConsumableArray(finalBackgroundLayers), _toConsumableArray(finalLayers)) // Description of controller property
        // https://deck.gl/docs/api-reference/core/deck#controller
        ,
        controller: controller || controller === false ? controller : {
          dragRotate: false
        },
        onHover: onHover
      })), Tooltip && tooltipData ? renderTooltip() : null]
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ReactResizeDetector, {
      handleHeight: true,
      handleWidth: true,
      onResize: onResizeHandler,
      refreshMode: "debounce",
      refreshRate: 500
    }), box.width && box.height ? renderMap() : null]
  });
};

DeckGlMap.propTypes = {
  onResize: PropTypes.func,
  onViewChange: PropTypes.func,
  viewLimits: PropTypes.object,
  view: PropTypes.object,
  onClick: PropTypes.func,
  onLayerClick: PropTypes.func,
  onZoomEnd: PropTypes.func,
  onPanEnd: PropTypes.func,
  mapKey: PropTypes.string,
  backgroundLayer: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  layers: PropTypes.array,
  Tooltip: PropTypes.func,
  tooltipProps: PropTypes.object,
  getCursor: PropTypes.func,
  controller: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
};
export default DeckGlMap;